import React, { useState, useEffect } from 'react';
import ItemsTable from './itemstable';
import constant from '../../constant';

const ItemsContent = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('role');
      const adminSelectedUser = localStorage.getItem('adminSelectedUser');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      let apiUrl = `${constant.REACT_APP_API_URL}/item`;

      if (userRole === 'admin' && adminSelectedUser) {
        apiUrl = `${constant.REACT_APP_API_URL}/item?userId=${adminSelectedUser}`;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          setItems(result.data);
        } else {
          setError(result.message || 'Failed to fetch items');
        }
      } catch (error) {
        setError('Error fetching items');
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, []);

  const handleDelete = (id) => {
    setItems(items.filter((item) => item._id !== id));
  };

  const handleEdit = (updatedItem) => {
    setItems(items.map((item) =>
      item._id === updatedItem._id ? updatedItem : item
    ));
  };


  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      {/* bg-white rounded-lg shadow */}
      <div className="">
        <div className="">
          <ItemsTable
            items={items}
            onDelete={handleDelete}
            onEdit={handleEdit}
          />
        </div>
      </div>
    </div>
  );
};

export default ItemsContent;
